module.exports = __webpack_public_path__ + "img/img_smart_img3.b98d6652.png";